import { Flex, IconButton, VisuallyHidden } from '@radix-ui/themes'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { RxCross1 } from 'react-icons/rx'

/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	uiCloseButton = 'ui-close-button',
}

/* -------------------------------------------------------------------------------------------------
 * CloseButton
 * -----------------------------------------------------------------------------------------------*/

type CloseButtonElement = React.ElementRef<typeof IconButton>
type CloseButtonProps = React.ComponentPropsWithoutRef<typeof IconButton> & {
	onClose: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const CloseButton = React.forwardRef<CloseButtonElement, CloseButtonProps>(
	(props, forwardedRef) => {
		const { onClose, ...rest } = props
		const { t } = useTranslation(I18NEXT.uiCloseButton)

		return (
			<Flex justify="end" mb="3" className="z-10">
				<IconButton
					ref={forwardedRef}
					radius="full"
					variant="ghost"
					color="gray"
					onClick={onClose}
					{...rest}
				>
					<VisuallyHidden>{t('button.modalClose')}</VisuallyHidden>
					<RxCross1 size=".9em" />
				</IconButton>
			</Flex>
		)
	},
)
CloseButton.displayName = 'CloseButton'

/* -----------------------------------------------------------------------------------------------*/

export { CloseButton, I18NEXT as CLOSE_BUTTON_I18NEXT }
